import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Crumb } from '@shared/models';
import { BreadcrumbMeta, PageMetaService } from '@spartacus/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'ui-custom-breadcrumbs',
  templateUrl: './custom-breadcrumb.component.html',
  styleUrls: ['./custom-breadcrumb.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CustomBreadcrumbComponent implements OnInit {
  crumbs$: Observable<any[]>;
  mobileCrumb$: Observable<Crumb>;

  constructor(private pageMetaService: PageMetaService) {}

  ngOnInit(): void {
    this.crumbs$ = this.pageMetaService.getMeta().pipe(
      map((meta) => {
        return meta?.breadcrumbs ? meta.breadcrumbs : [{ label: 'Главная', link: '/' }];
      }),
    );

    this.mobileCrumb$ = this.crumbs$.pipe(
      map((crumbs: BreadcrumbMeta[]) => {
        return crumbs[crumbs.length - 2];
      }),
    );
  }
}
